import { api_host } from '../constants'
import { apiFetch } from './apiRequestHandler'

export const revertPreviousState = async ({
  siteId,
  componentId,
  type,
  name = null,
  uri = null
}) => {
  return await apiFetch(`${api_host}/ai/revert`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      siteId,
      componentId,
      type,
      name,
      uri
    })
  })
}

export const savePreviousState = async ({
  siteId,
  componentId,
  type,
  name = null,
  value,
  uri = null
}) => {
  return await apiFetch(`${api_host}/ai/previous-state`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      siteId,
      componentId,
      type,
      name,
      value,
      uri
    })
  })
}

export const fetchPreviousStates = async ({
  siteId,
  componentId = null,
  uri = null
}) => {
  return await apiFetch(`${api_host}/ai/previous-states`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      siteId,
      componentId,
      uri
    })
  })
}

export const revertAllPreviousStates = async ({
  siteId,
  componentId,
  uri = null
}) => {
  return await apiFetch(`${api_host}/ai/revert-all`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      siteId,
      componentId,
      uri
    })
  })
}
